import { ofType } from 'redux-observable';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import { secondaryMarketAmendCpOrderFetchRequested } from 'state/secondaryMarket/cpOrder/cpOrderForm/original/cpOrderOriginalForm.actions';
import type { EpicWithThunk } from 'state/state.common';

export function fetchCpOrderAfterTabContentEpic(): EpicWithThunk {
  return (
    action$,
    state$,
    {
      selectors: {
        fromSecondaryMarket: {
          cpOrder: {
            form: { isCpOrderToAmendLoaded },
          },
        },
        fromSecondaryPostEventsWorkspace: { getOrderId },
      },
    },
  ) => {
    return action$.pipe(
      ofType('WORKSPACE_TAB_CONTENT_FETCHED'),
      filter(({ workspace, tabType }) => {
        return workspace === 'secondaryMarketPostEvents' && tabType === 'closePriceOrder';
      }),
      withLatestFrom(state$),
      filter(([{ tabId }, state]) => {
        return !isCpOrderToAmendLoaded(state, tabId);
      }),
      map(([{ tabId }, state]) => {
        const orderId = getOrderId(state, tabId);
        return secondaryMarketAmendCpOrderFetchRequested(tabId, orderId);
      }),
    );
  };
}
